<div class="d-flex flex-column min-vh-100 bg-light">
  <lib-nav-bar>
    <div class="nav-bar-content">
      <lib-button
        trailingIconName="new-window"
        [type]="ButtonType.secondaryDark"
        (buttonClick)="navbarButtonClicked()">
        {{ config.pgaSiteUrl }}
      </lib-button>
    </div>
  </lib-nav-bar>
  <div>
    <lib-content-header>
      <div class="font-title-large" i18n>Review Golf Industry Hours</div>
    </lib-content-header>
    <div class="content-container content-container-margin-top">
      <div class="row">
        <div class="col-main card-container">
          @let bannerConfig = this.bannerConfig();
          @if (bannerConfig) {
            <lib-large-banner [config]="bannerConfig"></lib-large-banner>
          }
          <div class="golf-hours-summary-card">
            <div class="golf-hours-summary">
              <div class="golf-hours-summary-title">
                <div class="font-title-small">
                  {{ viewModel.golfIndustryHours().memberName }}
                </div>
              </div>
              <lib-info-label leadingIconName="description" i18n>
                Submitted on
                {{ viewModel.golfIndustryHours().createdDate | date: DateUtils.isoToShorthandDateStringFormat() }}
              </lib-info-label>
            </div>
          </div>
          <lib-card titleText="Entry Details" i18n-titleText>
            <div class="row form-row">
              <lib-readonly-form-field class="col-6"
                                       label="Job Title"
                                       i18n-label
                                       [loading]="viewModel.isGolfIndustryHoursLoading()"
                                       [value]="viewModel.golfIndustryHours().jobTitle"></lib-readonly-form-field>
              <lib-readonly-form-field class="col-6"
                                       label="Hours"
                                       i18n-label
                                       [loading]="viewModel.isGolfIndustryHoursLoading()"
                                       [value]="`${viewModel.golfIndustryHours().hours | number: '.2-2'}`"></lib-readonly-form-field>
              <lib-readonly-form-field class="col-6"
                                       label="Employment Start Date"
                                       i18n-label
                                       [loading]="viewModel.isGolfIndustryHoursLoading()"
                                       [value]="viewModel.golfIndustryHours().employmentStartDate | date: DateUtils.dateToFullDateStringFormat()"></lib-readonly-form-field>
              <lib-readonly-form-field class="col-6"
                                       label="Employment End Date"
                                       i18n-label
                                       [loading]="viewModel.isGolfIndustryHoursLoading()"
                                       [value]="viewModel.golfIndustryHours().employmentEndDate | date: DateUtils.dateToFullDateStringFormat()"></lib-readonly-form-field>
              <lib-readonly-form-field class="col-12"
                                       label="List of Duties"
                                       i18n-label
                                       [loading]="viewModel.isGolfIndustryHoursLoading()"
                                       [value]="viewModel.golfIndustryHours().listOfDuties"></lib-readonly-form-field>
            </div>
          </lib-card>
          @if (viewModel.golfIndustryHours().status?.id === GolfIndustryHoursStatus.Pending) {
            <div class="d-flex gap-3">
              <lib-button [disabled]="viewModel.isStatusUpdateSubmitting()"
                          (buttonClick)="approveClicked()"
                          i18n>
                Approve Hours
              </lib-button>
              <lib-button [disabled]="viewModel.isStatusUpdateSubmitting()"
                          [type]="ButtonType.secondary"
                          (buttonClick)="denyClicked()"
                          i18n>Reject Hours
              </lib-button>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>
